import constants from '../../constants/constants'

export default {
    resizableSides: [constants.RESIZE_SIDES.LEFT, constants.RESIZE_SIDES.RIGHT],
    layoutLimits: {
        minWidth: 500
    }
}
